export default __webpack_public_path__ + "static/media/home3_bg.84660b84.png";